// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.admanagement.listingoperations.RentalManagerUserClaimableListingsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings,
  RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany,
  RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider,
  RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_Path,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_Path,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_Path,
  RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo,
  RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path,
  RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings,
  RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim,
  RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage,
  RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim,
  RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AllowedFeedDto,
  ClaimCustomerListingsRequestDto,
  ClaimCustomerListingsResponseDto,
  ClaimFeedCompanyResponseDto,
  CompanyPropertyClaimingDto,
  CustomerClaimedFeedCompanyDto,
  CustomerClaimingEmailMessageInfoDto,
  CustomerHasNewPropertiesToClaimResponseDto,
  ReleaseCustomerListingsRequestDto,
  ReleaseCustomerListingsResponseDto,
  SalesProUserInfoDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ClaimFeedCompanyParams {
  feedCompanyId: string;
  feedId: string;
}
interface GetClaimablePropertiesParams {
  pageSize?: number;
  startUnitId?: number;
  unitId?: number;
}
interface GetClaimablePropertiesFilteredParams {
  searchValue: string;
}
interface ReleaseFeedCompanyClaimParams {
  feedCompanyId: string;
  feedId: string;
}

export interface RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Args {
  postData: ClaimCustomerListingsRequestDto;
}

export type RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Options = UseMutationOptions<
  ClaimCustomerListingsResponseDto,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Args
>;

/**
 * Claim customer Listing
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings = (
  options: Omit<RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings(args.postData),
  });
};

export interface RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany_Args {
  getParams: ClaimFeedCompanyParams;
}

export type RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany_Options = UseMutationOptions<
  ClaimFeedCompanyResponseDto,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany_Args
>;

/**
 * Claim feed company
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany = (
  options: Omit<RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany(args.getParams),
  });
};

export type RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_Options = UseQueryOptions<
  Array<AllowedFeedDto>,
  unknown,
  Array<AllowedFeedDto>,
  readonly [string]
>;

const RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_GetKey = () =>
  [RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_Path] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_queryOptions = () =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_GetKey(),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider(),
  }) as const satisfies QueryOptions;

/**
 * get multifamily allowed feed list
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider = (
  options: Omit<
    RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_queryOptions(),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_GetKey;

export type RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Options = UseQueryOptions<
  CompanyPropertyClaimingDto,
  unknown,
  CompanyPropertyClaimingDto,
  readonly [string, GetClaimablePropertiesParams]
>;

const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_GetKey = (
  getParams: GetClaimablePropertiesParams,
) => [RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path, getParams] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_queryOptions = (
  getParams: GetClaimablePropertiesParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_GetKey(getParams),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties(getParams),
  }) as const satisfies QueryOptions;

/**
 * Return CompanyId claimable properties
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties = (
  getParams: GetClaimablePropertiesParams,
  options: Omit<
    RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_GetKey;

export type RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_Options = UseQueryOptions<
  CompanyPropertyClaimingDto,
  unknown,
  CompanyPropertyClaimingDto,
  readonly [string, GetClaimablePropertiesFilteredParams]
>;

const RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_GetKey = (
  getParams: GetClaimablePropertiesFilteredParams,
) => [RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_Path, getParams] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_queryOptions = (
  getParams: GetClaimablePropertiesFilteredParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_GetKey(getParams),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered(getParams),
  }) as const satisfies QueryOptions;

/**
 * Return Company claimable properties which PropertyName or Address match with searchValue
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered = (
  getParams: GetClaimablePropertiesFilteredParams,
  options: Omit<
    RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_GetKey;

export type RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_Options = UseQueryOptions<
  Array<CustomerClaimedFeedCompanyDto>,
  unknown,
  Array<CustomerClaimedFeedCompanyDto>,
  readonly [string]
>;

const RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_GetKey = () =>
  [RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_Path] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_queryOptions = () =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_GetKey(),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies(),
  }) as const satisfies QueryOptions;

/**
 * Return claimed feed company list
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies = (
  options: Omit<
    RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_queryOptions(),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_GetKey;

export type RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Options = UseQueryOptions<
  Array<SalesProUserInfoDto>,
  unknown,
  Array<SalesProUserInfoDto>,
  readonly [string]
>;

const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_GetKey = () =>
  [RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_queryOptions = () =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_GetKey(),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo(),
  }) as const satisfies QueryOptions;

/**
 * Return Logged User Sales Pro's Name and Email
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo = (
  options: Omit<
    RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_queryOptions(),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_GetKey;

export interface RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Args {
  postData: ReleaseCustomerListingsRequestDto;
}

export type RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Options = UseMutationOptions<
  ReleaseCustomerListingsResponseDto,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Args
>;

/**
 * Release customer Listing
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings = (
  options: Omit<RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings(args.postData),
  });
};

export interface RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim_Args {
  getParams: ReleaseFeedCompanyClaimParams;
}

export type RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim_Args
>;

/**
 * Release feed company claim
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim = (
  options: Omit<RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim(args.getParams),
  });
};

export interface RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Args {
  postData: CustomerClaimingEmailMessageInfoDto;
}

export type RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Args
>;

/**
 * Sent customer message to sales pro's Email
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage = (
  options: Omit<RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage(args.postData),
  });
};

export type RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Options = UseQueryOptions<
  CustomerHasNewPropertiesToClaimResponseDto,
  unknown,
  CustomerHasNewPropertiesToClaimResponseDto,
  readonly [string]
>;

const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_GetKey = () =>
  [RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_queryOptions = () =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_GetKey(),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim(),
  }) as const satisfies QueryOptions;

/**
 * check if user has new properties to claim
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim = (
  options: Omit<
    RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_queryOptions(),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_GetKey;
